import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { api } from "./index.api";
import { Course } from "../../types/course";
import { FilterQuery, PaginationQuery } from "../../types/query";

const courseEntityAdapter = createEntityAdapter<Course, string>({
  selectId: (item: Course) => item._id,
});

export type GetCoursesDTO = {
  courses: EntityState<Course, string>;
  length: number;
  from: number;
};

const courseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addCourse: builder.mutation<Partial<Course> | undefined, FormData>({
      query: (input) => ({
        url: `/admin/courses`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return ["courses"];
      },
    }),

    getCourses: builder.query<
      GetCoursesDTO,
      FilterQuery<Course & PaginationQuery>
    >({
      query: (input) => ({
        url: "/courses",
        params: input,
      }),
      transformResponse(
        baseQueryReturnValue: { courses: any; length: number; from: number },
        meta,
        arg
      ) {
        return {
          courses: courseEntityAdapter.addMany(
            courseEntityAdapter.getInitialState(),
            baseQueryReturnValue.courses as any
          ),
          length: baseQueryReturnValue.length,
          from: baseQueryReturnValue.from,
        };
      },
      providesTags: ["courses"],
    }),

    updateCourse: builder.mutation<void, { data: FormData; courseId: string }>({
      query: (input) => ({
        url: `/admin/courses/${input.courseId}`,
        method: "PUT",
        body: input.data,
      }),
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return ["courses"];
      },
    }),

    deleteCourse: builder.mutation<void, string>({
      query: (input) => ({
        url: `/admin/courses/${input}`,
        method: "DELETE",
      }),
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return ["courses"];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCoursesQuery,
  useAddCourseMutation,
  useDeleteCourseMutation,
  useUpdateCourseMutation,
} = courseApi;
